/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_SiteInputs */

const fr_legal_site = /** @type {(inputs: Legal_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site :`)
};

const en_legal_site = /** @type {(inputs: Legal_SiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website:`)
};

/**
* | output |
* | --- |
* | "Website:" |
*
* @param {Legal_SiteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_site = /** @type {((inputs?: Legal_SiteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_SiteInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_site(inputs)
	return en_legal_site(inputs)
});